// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1j5q8","right":"styles_right__1U6kn"};